// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.12343"][{"4779":0}[chunkId]] || "1.12348") + "/" + chunkId + ".js";
};